import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

var state = function state() {
  return {
    total: 0,
    items: [],
    success: false,
    successServer: true,
    cartState: 'LOADING'
  };
};

export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};